import { useGrupo } from '../../hooks/useGrupos';
import { useEffect } from 'react';
import { useGrupoContext } from '../../context/GroupContext';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Modal, Button, Select, Form, Alert } from 'antd';

interface IModalRepublicarGrupoProps {
    hook: ReturnType<typeof useGrupo>;
}

export const ModalRepublicarGrupos = ({ hook }: IModalRepublicarGrupoProps) => {
    const description = `Reenvia os dados de todos os grupos para o sistema. Use apenas em casos de inconsistência ou informações desatualizadas. A atualização pode levar alguns minutos para aparecer no aplicativo e no dashboard.`;

    const [form] = Form.useForm();

    const {
        isRepublicarOpen,
        fecharModalGrupo,
    } = useGrupoContext();

    const {
        sistemasGrupos,
        loadingGrupoModal,
        getSistemasGrupos,
        postRepublicarSistemaGrupos,
    } = hook;

    const handleFinish = async (values: { grupo: string }) => {
        postRepublicarSistemaGrupos(values.grupo);
        fecharModalGrupo();
    };

    const optionsGrupos = sistemasGrupos?.map((grupo) => ({
        label: grupo.charAt(0).toUpperCase() + grupo.slice(1),
        value: grupo,
    }));

    useEffect(() => {
        getSistemasGrupos();
    }, []);

    return (
        <Modal
            destroyOnClose
            title={'Republicar grupos'}
            open={isRepublicarOpen}
            onCancel={fecharModalGrupo}
            footer={[
                <Button
                    key="back"
                    onClick={fecharModalGrupo}
                >
                    Fechar
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    disabled={loadingGrupoModal}
                    loading={loadingGrupoModal}
                    style={{
                        backgroundColor: '#008000',
                        borderColor: '#008000',
                    }}
                    onClick={() => form.submit()}
                >
                    Salvar
                </Button>
            ]}
        >
            <Form
                form={form}
                layout="vertical"
                preserve={false}
                onFinish={handleFinish}
                initialValues={{
                    grupo: 'todos',
                }}
            >
                <Alert
                    icon={<InfoCircleOutlined />}
                    showIcon
                    message="Atenção!"
                    description={description}
                    type="warning"
                />
                <Form.Item
                    name="grupo"
                    rules={[
                        {
                            required: true,
                            message: 'Selecione um grupo',
                        },
                    ]}
                    style={{
                        marginTop: 24,
                    }}
                >
                    <Select
                        placeholder="Selecione um grupo"
                        options={optionsGrupos}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};
